export default __webpack_public_path__ + "d4d147cb328b627388467f9bd90d5a6f.png";